import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as userActions from '../store/actions/user';
import {
  Router,
  Route,
  Link,
  Switch,
} from 'react-router-dom';
import history from './history';
import Cookies from 'js-cookie';
import _ from 'lodash';
import { LocaleProvider, Menu, Icon, Layout, Row, Col, Breadcrumb } from 'antd';
import routers from './routers';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import { Scrollbars } from 'react-custom-scrollbars';
import Header from '../components/Header/Header';
import SiderMenu from '@/components/sider/SiderMenu';
import utils from '../api/util';
import { } from '../api/api'
import './index.css';
import { request } from 'http';

const SubMenu = Menu.SubMenu;
const { Content, Footer } = Layout;

class Home extends Component {
  constructor(props) {
    super(props);
    console.log(props)
    this.state = {
      user: this.props.user,
      _height: '100%',
      indexBg: "",
      projectName: ""
    }
  }

  componentWillMount() {
    let user = localStorage.getItem('user');
    if (user) {
      let httpStr = window.location.host.startsWith('http') ? '' : 'http://';
      this.setState({
        user: JSON.parse(user),
        treeList: JSON.parse(user).treeList,
        indexBg: httpStr + window.location.host + '/labpro' + JSON.parse(user).dirPath + 'Index.jpg',//首页背景图片
      });
      this.props.updateUserInfo(JSON.parse(user));
    }
  }

  componentDidMount() {
    const that = this;
    console.log(this.props)
    console.log(this.props.children)
    let path = this.props.children.props.match.path;
    this.currentRouter = _.find(routers, ['path', path])//返回的是一个对象
    console.log(this.currentRouter)
    //新增
    let params = {
      proId: this.props.children.props.match.params.proId,
      page: 1,
      rows: 1000,
    };
    (params, res => {
      console.log(params)
      console.log(res)
      let projectName = res.rows[0].projectName;
      if (projectName.length >= 13) {
        projectName = projectName.substring(0, 12) + '...'
      }
      this.setState({
        projectName: projectName
      })
    }, err => {
      console.log(err)
    })

    let _HeightBody = document.documentElement.clientHeight;
    this.setState({
      _height: _HeightBody + 'px'
    })
  }


  render() {
    const { children: { props } } = this.props
    console.log(props)
    console.log(this.state.user)
    const { _height, indexBg, projectName } = this.state;
    return (
      <Layout className="layout bodyWrapper" style={{ height: _height }}>
        <SiderMenu user={this.state.user}></SiderMenu>
        <Layout>
          <Header user={this.state.user} path={props.match.path}></Header>
          <Scrollbars className='myScroll' style={{
            flex: 1,
            //  backgroundImage: `url(${this.state.indexBg})`,
            // backgroundSize: '100% 100%'
          }} autoHide>
            <Content className={props.match.path === '/myList' ? '' : "body_Con"}
              style={{ width: props.match.path === '/myList' ? '100%' : screen.width == 1920 ? '82%' : '100%' }}
            >
              <LocaleProvider
                locale={zh_CN}
              >
                {this.currentRouter && this.currentRouter.breadcrumb
                  &&
                  <Breadcrumb>
                    <Breadcrumb.Item><i className="iconfont icon-shouye"></i><Link to="/homePage" className='breadcrumb'>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><span className='c_8bff'>{this.currentRouter.name}</span></Breadcrumb.Item>
                  </Breadcrumb>
                }
                {this.props.children}
              </LocaleProvider>
            </Content>
            {props.match.path !== '/myList' && <Footer className="tc mt20 mb20 f12 c_66" style={{ background: 'transparent' }}>Copyright (©) 2020湖南巨擘科技有限公司版权所有 湘ICP备18016499号</Footer>}
          </Scrollbars>
        </Layout>
        {/* <Header user={this.state.user}></Header>
        <Content className="body_Con">
          <LocaleProvider locale={zh_CN}>
            {this.currentRouter && this.currentRouter.breadcrumb
              &&
              <Breadcrumb>
                <Breadcrumb.Item><i className="iconfont icon-shouye"></i><Link to="/homePage">首页</Link></Breadcrumb.Item>
                <Breadcrumb.Item>{this.currentRouter.path === "/projects_child/:proId" ? projectName : this.currentRouter.name}</Breadcrumb.Item>
              </Breadcrumb>
            }
            {this.props.children}
          </LocaleProvider>
        </Content>
        <Footer className="tc mt20 mb20 f12 c_66" style={{ background: 'transparent' }}>版权所有 2020 杂交水稻国家重点实验室</Footer> */}
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(userActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
